import React from 'react';
import { useTheme } from '../context/ThemeContext';

function Subscribe() {
  const { theme } = useTheme();
  return (
    <div className={`container mx-auto p-8 ${theme.text} opacity-90`}>
      <div className={`${theme.cardBg} rounded-lg mt-8 shadow-lg p-6 border ${theme.border}`}>
        <h1 className="text-3xl font-bold mb-6">Subscribe to ATLTech.events<sup>SM</sup></h1>

        <div className="space-y-4 text-left">
          <p>
            We've also launched a newsletter to keep you updated on the latest events and news in the tech community.
          </p>
          <p>
          <a href="https://eventhorizonmedia.substack.com/s/atl-tech-events" target="_blank" rel="noopener noreferrer" className={theme.link}>Subscribe to the ATLTech.events newsletter</a>
          </p>
          <p>
            We'll publish a weekly newsletter with the upcoming events for the week. It's free and you can unsubscribe at any time. Paid subscriptions are available to support our work.
          </p>

          <p>Our newsletter is produced by Event Horizon Media, a media service of Mirability, LLC. Through Event Horizon Media, we'll be able to expand to different cities and event types. Interested in a specific event type or city? Let us know!</p>

          <h2 className="text-2xl font-bold mt-6 mb-3">Event Horizon Media<sup>SM</sup></h2>
          <p className="flex justify-center">
          <img src="event-horizon-media-logo.png" alt="Event Horizon Media Logo" className="w-1/2 rounded-full" />
          </p>
          <p>
          Event Horizon Media is a media and event platform service of Mirability, LLC, that produces the ATLTech.events calendar and newsletter. Want to see the platform in your city? Let us know!
          </p>

        </div>
      </div>
    </div>
  );
}

export default Subscribe;
